<template>
  <div class="open-app">
    <p>앱을 여는 중입니다... 잠시만 기다려주세요.</p>
    <img
      class="loading-gif"
      src="@/assets/images/loading-icon.gif"
      alt="loading"
    />
    <a ref="realLink" :href="link" style="display: none">이동</a>
  </div>
</template>

<script>
export default {
  computed: {
    link(){
      const encoded = encodeURIComponent(this.$route.fullPath.split("target=")[1]);
      return  `openapp?target=${encoded}`;
    }
  },
  mounted() {
    this.$refs.realLink.click();
  },
};
</script>

<style scoped>
.open-app {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30vh;
  font-size: 18px;
  flex-direction: column;
}
.loading-gif {
  padding-top: 20px;
  width: 15%;
}
</style>